/**
 * Permet de créer un mixin qui généré les beforeRouterEnter et beforeRouteUpdate.
 *
 * Les arguments sont
 *
 * {
 *  next() le callback qui accepte {vm, body, error}
 *  promise({}), la fonction qui recoit les arguments de la route extrait grace aux ids ou null si pas d'argument
 *  ids=["id"], la liste des parametres à transmettre
 * }
 *
 * Il est possible de split les argument en onLoad (avec les mêmes parametres, pour gérer le cas sans id) et onLoadId pour gérer le cas avec id
 *
 * @param {*} argument
 * @returns
 */
export default function makeRouteLoader(argument) {
  const onLoad = argument.onLoad ? argument.onLoad : argument;
  const onLoadId = argument.onLoadId ? argument.onLoadId : argument;
  const shallUpdate = argument.shallUpdate;
  const ids = argument.ids || ["id"];



  function withIdLoader(next, id, ko, to) {
    onLoadId
      .promise(id)
      .then(body => {
        next(vm => onLoadId.next({ vm, body, to }));
      })
      .catch(error => ko(error));
  }

  function withLoader(next, ko) {
    onLoad
      .promise()
      .then(body => {
        next(vm => {
          onLoad.next({ vm, body });
        });
      })
      .catch(error => ko(error));
  }

  function extractIds(to) {
    if (ids.every(id => to.params[id] !== null)) {
      return to.params;
    } else {
      return null;
    }
  }

  return {
    beforeRouteEnter(to, from, next) {
      const ko = () => next(false);
      const extracts = extractIds(to);
      if (extracts) {
        withIdLoader(next, extracts, ko);
      } else {
        withLoader(next, ko);
      }
    },

    beforeRouteUpdate(to, from, next) {
      const me = this;
      const nextWrapper = action => {
        action(me);
        next();
      };

      if (shallUpdate && !shallUpdate(me, to, from)) {
        next();
        return;
      }

      const extracts = extractIds(to);
      if (extracts) {
        const ko = error => onLoadId.next({ vm: me, error });
        withIdLoader(nextWrapper, extracts, ko, to);
      } else {
        const ko = error => onLoad.next({ vm: me, error });
        withLoader(nextWrapper, ko);
      }
    },
  };
}
